
/**
 * Utility functions to handle transaction status mappings
 */

/**
 * Maps the tab value to the actual Stripe status filter string
 */
export const getStatusFilterForTab = (tab: string): string | undefined => {
  switch (tab) {
    case 'succeeded':
    case 'all':
      return 'succeeded';
    case 'pending':
      // Include all pending-like statuses
      return 'requires_payment_method,processing,requires_action,requires_capture';
    case 'failed':
      return 'canceled,failed';
    default:
      return undefined; // all transactions
  }
};

/**
 * Determines the tab value based on a provided status filter
 */
export const getTabValueFromStatus = (filterStatus: string = 'all'): string => {
  if (filterStatus === 'succeeded') {
    return 'succeeded';
  } else if (
    filterStatus.includes('requires_') || 
    filterStatus === 'processing'
  ) {
    return 'pending';
  } else if (
    filterStatus === 'failed' || 
    filterStatus === 'canceled'
  ) {
    return 'failed';
  }
  
  return 'all';
};
